<template>
  <div class="mypage-container">
    <h1 class="mypage-title">마이페이지</h1>
    <MyPageDashboardVue />
    <div class="mypage-section">
      <MyPageOrderVue />
    </div>
    <div class="mypage-section">
      <MyPageMyInfoVue />
    </div>
    <MyPageNavigatorVue />
  </div>
</template>

<script>
import MyPageDashboardVue from '@/components/MyPage/MyPageDashboard.vue'
import MyPageNavigatorVue from '@/components/MyPage/MyPageNavigator.vue'
import MyPageOrderVue from '@/components/MyPage/MyPageOrder/MyPageOrder.vue'
import MyPageMyInfoVue from '@/components/MyPage/MyPageMyInfo/MyPageMyInfo.vue'

export default {
  name: 'MyPage',
  components: {
    MyPageDashboardVue,
    MyPageNavigatorVue,
    MyPageOrderVue,
    MyPageMyInfoVue
  },
  mounted() {
    window.scrollTo(0,0)
  }
}
</script>

<style>
.mypage-container {
  display: flex;
  flex-direction: column;
  max-width: 720px;
  margin: 0 auto;
  padding: 40px 24px 60px;
  box-sizing: border-box;
  font-family: var(--font-sans);
}
.mypage-title {
  margin: 0 0 24px;
  font-size: 24px;
  font-weight: var(--font-weight-bold);
  color: var(--text-heading);
  text-align: left;
}
.mypage-section {
  margin-top: 24px;
}
</style>